import {
    CommonRoutes,
    FilterType, IconType,
} from 'app/enums/common.enums'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    RequestConfig,
} from 'app/types/request.types'
import {
    ServiceCenterTabs,
} from 'app/enums/domain.enums'
import {
    ServiceCentersTableType,
} from 'app/Apps/ContainerManagement/ServiceCenters/serviceCenters.types'
import {
    RegionZeroLevel,
    ServiceCenterStatus,
    ServiceCenterType,
    ServiceProcess,
} from 'app/enums/label.enums'

import serviceCenterRequests from 'app/requests/ServiceCenter/ServiceCenter.requests'
import {
    SkyDataGridColumnDefinition,
} from 'app/shared-components/SkyBaseDataGrid'
import TextIcon from 'app/common/DomainObject/ComponentMapper/TextIcon'
import {
    SkyNetObjectConfigParams,
} from 'app/shared-components/SkyNetObjectProfile'
import ServiceCentersDemoScenarioEditor from './ServiceCentersDemoScenarioEditor'

const columns: SkyDataGridColumnDefinition<ServiceCentersTableType>[] = [
    {
        name: 'serviceCenterNumber',
        reduced: true,
        renderCell: ({
            row: {
                serviceCenterNumber,
                estimatedClosureDate,
            },
        }) => {
            return (
                <TextIcon
                    value={serviceCenterNumber}
                    type={estimatedClosureDate ? IconType.OrangeWarning : undefined}
                    tooltip={`Estimated Closure Date ${estimatedClosureDate}`}
                    // TODO-JG: after moving each table where TextIcon is used,
                    // change default color inside component to black instead of secondary[600]
                    // and remove this override
                    textStyles={{
                        color: !estimatedClosureDate ? 'inherit' : undefined,
                    }}
                />
            )
        },
        labelKey: 'SERVICE_CENTER',
    },
    {
        name: 'locationLocationName',
        filterField: 'locationLocationName',
        filterType: FilterType.Array,
        labelKey: 'LOCATION',
        reduced: true,
    },
    {
        name: 'serviceCenterStatus',
        filterField: 'serviceCenterStatus',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: ServiceCenterStatus,
        labelKey: 'STATUS',
    },
    {
        name: 'serviceCenterType',
        filterField: 'serviceCenterType',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: ServiceCenterType,
        labelKey: 'TYPE',
    },
    {
        name: 'orderSelectionDelay',
        labelKey: 'ORDER_SELECTION_DELAY',
    },
    {
        name: 'enabledProcesses',
        componentName: 'EnumList',
        allowedValuesEnum: ServiceProcess,
        labelKey: 'ENABLED_PROCESSES',
    },
    {
        name: 'regionZeroLevel',
        filterField: 'regionZeroLevel',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: RegionZeroLevel,
        labelKey: 'REGION_LEVEL_0',
    },
]

const request: RequestConfig = {
    url: 'servicecenter/filter-request/all',
    method: 'POST',
}

export const formViews = [{
    label: 'Scenario Editor',
    url: ServiceCenterTabs.ScenarioEditor,
    Component: ServiceCentersDemoScenarioEditor,
    skyNetQueryLoaderConfig: {
        requestConfigFunction: serviceCenterRequests.get,
        requestKey: RequestKeys.getServiceCenterById,
    },
}]

const ServiceCentersDemoConfig: SkyNetObjectConfigParams<ServiceCentersTableType> = {
    persistentKey: 'demo-serviceCenters-table',
    formViews,
    columns,
    uniqField: 'id',
    config: [{
        url: CommonRoutes.All,
        name: 'All',
        requestKey: RequestKeys.getServiceCenters,
        request,
    }],
}

export default ServiceCentersDemoConfig
